import { IExportColumnModel } from "../../../../../shared/models";

export const TagLocationColumnList: IExportColumnModel[] = [
]